import * as tool from '../api/common';
//import const_data from '../api/const_data';

const actions = {


    //聊天消息（接收到的消息）
    act_push_message(context, receive_msg) {
        //接收检测
        if (!tool.receive_check(context, receive_msg)) {
            return false;
        }

        //接收管理员端系统消息（警告，封号）
        tool.receive_sys(context, receive_msg);
        
        //播放声音
        if(context.state.objVal.hasOwnProperty("setting")){
            if(context.state.objVal.setting.msg_vol_2){
                if (context.state.objVal.voice_state == 0) {
                    tool.playSound_receive();
                }
            }
        }
        context.commit('push_message', receive_msg);

        tool.receive_After(context, receive_msg);
    },

    act_set_online_count(context, v) {
        var count = 1;
        if (v) {
            count = v;
        }
        context.commit('get', {
            url: '/App/GetOnlineCount/?count=' + count,
            success: function (data2) {
                context.commit('set_online_count', data2)
            },
            error: function (err) {
            }
        });
    },

    /* -------------state 常用操作封装------------------- */

    //获取用户信息，支持多条用户信息(uid=uid1,uid2,uid3....)
    act_get_userinfo: function (context, data) {
        var userinfo = context.state.userinfo;
        var http_must = false;
        if (data.http_must) {
            http_must = true;
        }

        var uid = data.uid;
        var arr_uid = uid.split(',');
        var userinfos = [];
        for (var i = 0; i < arr_uid.length; i++) {
            var idx = tool.hasKey(userinfo, arr_uid[i], 'uid');
            if (idx >= 0) {
                var info = userinfo[idx];
                userinfos.push(info);
            }
        }

        if (userinfos.length == arr_uid.length && !http_must) {
            //本地取数据
            if (userinfos.length == 1) {
                data.success(userinfos[0]);
            }
            else {
                data.success(userinfos);
            }
        }
        else {
            context.commit('get', {
                url: '/App/User_Get_FullUserInfo/?uid=' + uid,
                success: function (userinfo_serve) {
                    if (userinfo_serve instanceof Array) {
                        //返回多条数据的情况
                        for (var ii in userinfo_serve) {
                            var user_info_item = userinfo_serve[ii];
                            context.commit('push_userinfo', user_info_item);
                        }
                    }
                    else {
                        //返回单条数据的情况
                        var user_info_item = userinfo_serve;
                        context.commit('push_userinfo', user_info_item);
                    }
                    data.success(userinfo_serve);
                },
                error: function (err) {
                    console.log('http error...');
                    data.error(err);
                }
            });

        }
    },

    act_reload_userinfo: function (context, data) {
        if (!data) {
            var uid = context.state.uid;
            data = {
                "uid": uid,
                success: function (rst) {}
            }
        }
        
        if (typeof data === "string") {
            var uids = data;
            data = {
                "uid": uids,
                success: function (rst) {}
            }
        }
        
        data.http_must = true;
        context.dispatch('act_get_userinfo', data);
    },

    //收到对方的拉黑消息
    act_receive_sys: function (context, msg) {
        if (msg.type == '拉黑') {
            var uid = context.state.uid;
            context.dispatch('act_push_mycomplain', uid);
            context.dispatch('act_push_complainmy', uid);
        }
    },

    //拉黑用户
    act_push_mycomplain(context, uid) {
        context.commit('get', {
            url: '/App/Get_MyComplain_Lahei/?uid=' + uid,
            success: function (data_serve) {
                if (data_serve) {
                    var item;
                    for (var i = 0; i < data_serve.length; i++) {
                        item = data_serve[i];
                        context.commit('push_my_complain', item);
                    }
                }
            },
            error: function (err) {
                console.log('http error...');
            }
        });
    },
    act_push_complainmy(context, uid) {
        context.commit('get', {
            url: '/App/Get_ComplainMy_Lahei/?uid=' + uid,
            success: function (data_serve) {
                if (data_serve) {
                    var item;
                    for (var i = 0; i < data_serve.length; i++) {
                        item = data_serve[i];
                        context.commit('push_complain_my', item);
                    }
                }
            },
            error: function (err) {
                console.log('http error...');
            }
        });
    },

    //获取封号信息 
    act_get_killinfo(context, uid) {
        context.commit('get', {
            url: '/App/GetKillInfo/?uid=' + uid,
            success: function (data_serve) {
                if (data_serve.state == '1') {
                    context.commit('set_kill_info', data_serve);
                }
            },
            error: function (err) {
                console.log('http error...');
            }
        });
    },
    /* -------------state 常用操作封装------------------- */


    /* ------------- 金币、积分 操作------------------- */
    //后台扣除金币
    act_sub_coin: function (context, data) {
        context.commit('post', {
            url: '/App/Coin_Sub',
            data: { 'uid': data.uid, 'data': data.strSend },
            success: function (serve_data) {
                //重新加载用户信息
                context.dispatch('act_reload_userinfo', {
                    uid: data.uid,
                    success: function (u) {
                        //console.log('用户数据刷新成功');
                    }
                });

                data.success(serve_data);
            },
            error: function (err) {
                data.error(err);
            }
        });
    },

    //后台增加积分
    act_add_score: function (context, data) {
        context.commit('post', {
            url: '/App/Score_Add',
            data: { 'uid': data.uid, 'data': data.strSend },
            success: function (serve_data) {
                //重新加载用户信息
                context.dispatch('act_reload_userinfo', {
                    uid: data.uid,
                    success: function (u) {
                        //console.log('用户数据刷新成功');
                    }
                });

                data.success(serve_data);
            },
            error: function (err) {
                data.error(err);
            }
        });

    },

    //(增加积分)添加好友，同意添加
    add_score: function (context, data) {
        var uid = data.uid_from;
        var send_data = {
            'uid_from': data.uid_from,
            'uid_to': data.uid_to,
            'amount': data.amount,
            'type_dtl': data.type_dtl,
            'comment': data.comment
        };

        context.dispatch('act_add_score', {
            'uid': uid,
            'strSend': JSON.stringify(send_data),
            success: function (res) {
            }
        });
    },

    //收到礼物处理
    act_receive_gift: function (context, msg) {
        var const_data = context.state.const_data;
        if (msg.type == 'gift') {
            var gift_item = {};
            var gift_url = msg.txt;
            var arr_gift = const_data.gift_1.concat(const_data.gift_2);
            var idx = tool.hasKey(arr_gift, gift_url, 'url');
            if (idx >= 0) {
                gift_item = arr_gift[idx];
            }
            else{
                gift_item = arr_gift[0];
            }

            var uid = context.state.uid;
            var send_data = {
                'uid_from': uid,
                'uid_to': msg.from,
                'amount': gift_item.score,
                'type_dtl': '收到礼物',
                'comment': gift_item.name
            };

            context.dispatch('act_add_score', {
                'uid': uid,
                'strSend': JSON.stringify(send_data),
                success: function (res) {
                }
            });
        }
    },
    
    /* ------------- 金币、积分 操作------------------- */


    /* -------------好友相关操作------------------- */
    setFriendRel: function (context, data) {
        context.commit('get', {
            url: '/App/SetFriendRel/?uid_from=' + data.uid_from + '&uid_to=' + data.uid_to,
            success: function (data_serve) {
                if (data_serve.state == '1') {
                    data.success(data_serve);
                    //刷新当前用户好友列表
                    var uid = context.state.uid;
                    context.dispatch('act_getFriend', uid);
                }
                else{
                    data.fail(data_serve);
                }
            },
            error: function (err) {
                data.error(err);
                console.log('http error...');
            }
        });
    },

    act_getFriend: function (context, uid) {
        context.commit('get', {
            url: '/App/GetFriends/?uid=' + uid ,
            success: function (data_serve) {
                if (data_serve) {
                    //刷新当前用户好友列表
                    context.commit('push_my_friend',data_serve);
                }
            },
            error: function (err) {
                //data.error(err);
                console.log('http error...');
            }
        });
    }


}

export default actions;